import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bitumen',
  templateUrl: './bitumen.component.html',
  styleUrls: ['./bitumen.component.scss']
})
export class BitumenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
